import { CONFIG as RUNNER_WORKFLOW_CONFIG } from '@/workflow-runner/_data/config/config';
import { CONFIG as BUILDER_WORKFLOW_CONFIG } from '@/workflow-builder/_data/config';
import type { AdapterMode } from '@/workflow/_contract/mode';
import type { RegisteredConfig } from '@/workflow/modes/_@shared/_contract/registry';

export const CONFIG_BY_MODE = {
    builder: BUILDER_WORKFLOW_CONFIG,
    runner: RUNNER_WORKFLOW_CONFIG,
} as const satisfies Record<AdapterMode, RegisteredConfig>;

export const DEFAULT_MODE_CONFIG = RUNNER_WORKFLOW_CONFIG;
